export default __webpack_public_path__ + "static/media/help.29ba4c3f.svg";